module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-79fe2800d28ef6b6cb3ce96f9603560b.png";